module.exports = __webpack_public_path__ + "media/images/common/icon-map-0d5e1c5eb7a1c5fa6685bb7a397e4ac9.png";